import _extends from "@babel/runtime/helpers/extends";
import { Dropdown as DropdownComponent } from '@atlaskit/editor-common/ui-menu';
import React, { useContext } from 'react';
import { KeyDownHandlerContext } from '../ToolbarArrowKeyNavigationProvider';
var Dropdown = /*#__PURE__*/React.memo(function (_ref) {
  var props = _extends({}, _ref);
  var keydownHandlerContext = useContext(KeyDownHandlerContext);
  return (
    /*#__PURE__*/
    //This context is to handle the tab, Arrow Right/Left key events for dropdown.
    //Default context has the void callbacks for above key events
    React.createElement(DropdownComponent, _extends({
      keyDownHandlerContext: keydownHandlerContext
    }, props))
  );
});
export default Dropdown;